import {
  CLEAR_APPLICATION_STATE,
  GET_APPLICATION_STATE,
  SET_APPLICATION_STATE,
} from "./ApplicationStateTypes";

const initialState = {
  userState: {},
  messageState: {},
  groupState: {},
  allActiveState: {},
  scheduledSendState: {},
  sendHistoryState: {},
  eventState: {},
  adminUserState: {},
  adminAccountState: {},
  adminMsgTemplateState: {},
  emailTemplateState: {},
  profileState: {},
  privacyPolicyState: {},
  termsConditionState: {},
};

const ApplicationStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_APPLICATION_STATE:
      return {
        ...state,
      };
    case SET_APPLICATION_STATE:
      return {
        ...state,
        userState: action.payload.userState,
        messageState: action.payload.messageState,
        groupState: action.payload.groupState,
        allActiveState: action.payload.allActiveState,
        scheduledSendState: action.payload.scheduledSendState,
        sendHistoryState: action.payload.sendHistoryState,
        eventState: action.payload.eventState,
        adminUserState: action.payload.adminUserState,
        adminAccountState: action.payload.adminAccountState,
        adminMsgTemplateState: action.payload.adminMsgTemplateState,
        emailTemplateState: action.payload.emailTemplateState,
        profileState: action.payload.profileState,
        privacyPolicyState: action.payload.privacyPolicyState,
        termsConditionState: action.payload.termsConditionState,
      };

    case CLEAR_APPLICATION_STATE:
      return {
        ...state,
        userState: null,
        messageState: null,
        groupState: null,
        allActiveState: null,
        scheduledSendState: null,
        sendHistoryState: null,
        eventState: null,
        adminUserState: null,
        adminAccountState: null,
        adminMsgTemplateState: null,
        emailTemplateState: null,
        profileState: null,
        privacyPolicyState: null,
        termsConditionState: null,
      };
    default:
      return state;
  }
};

export default ApplicationStateReducer;
